module.exports = __webpack_public_path__ + "resources/img/img_alyac3_en.bad94c533b7c2298f90c66d050fc595e.png";